import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Envelope, People, PersonPlus, Shop } from 'react-bootstrap-icons';

export function AdminDashboard({ idToken, onNavigate }) {
  const [stats, setStats] = useState({
    marketplace: 0,
    leads: 0,
    professionals: 0
  });
  const [isLoading, setIsLoading] = useState(true);

  // Marketplace leads count (currently using mock data)

  const fetchStats = useCallback(async () => {
    if (!idToken) return;

    try {
      const [leadsRes, professionalsRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_CORE_API}/lead`, { headers: { Authorization: idToken } }),
        axios.get(`${process.env.REACT_APP_QMI_BASE_API}/professional`, { headers: { Authorization: idToken } })
      ]);

      const leads = leadsRes.data || [];
      setStats({
        marketplace: leads.filter(l => l.status === 'ForSale').length,
        leads: leads.filter(l => l.status === 'Inquiry').length,
        professionals: professionalsRes.data?.length || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setIsLoading(false);
    }
  }, [idToken]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const statCards = [
    {
      label: 'Marketplace Leads',
      value: stats.marketplace,
      icon: Shop,
      variant: 'primary',
      navigateTo: 'marketplace'
    },
    {
      label: 'Quote Requests',
      value: stats.leads,
      icon: Envelope,
      variant: '',
      navigateTo: 'quote-leads'
    },
    {
      label: 'Professionals',
      value: stats.professionals,
      icon: People,
      variant: '',
      navigateTo: 'professionals'
    },
];

  const handleCardClick = (navigateTo) => {
    if (onNavigate) {
      onNavigate(navigateTo);
    }
  };

  return (
    <div>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Dashboard</h1>
        <p className="admin-page-description">Overview of your QMI admin panel</p>
      </div>

      {/* Stats Grid */}
      <div className="admin-stats-grid">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div
              key={index}
              className={`admin-stat-card ${stat.variant}`}
              onClick={() => handleCardClick(stat.navigateTo)}
              style={{ cursor: 'pointer' }}
            >
              <div className="admin-stat-header">
                <span className="admin-stat-label">{stat.label}</span>
                <div className="admin-stat-icon">
                  <Icon size={20} />
                </div>
              </div>
              <div className="admin-stat-value">
                {isLoading ? '...' : stat.value}
              </div>
            </div>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="admin-card">
        <div className="admin-card-header">
          <h3 className="admin-card-title">Quick Actions</h3>
        </div>
        <div className="admin-card-body">
          <p style={{ color: 'var(--qmi-gray-500)' }}>
            Click on any card above to navigate, or use the navigation tabs.
          </p>
        </div>
      </div>
    </div>
  );
}
